import script from "./Order.vue?vue&type=script&setup=true&lang=js"
export * from "./Order.vue?vue&type=script&setup=true&lang=js"

import "./Order.vue?vue&type=style&index=0&id=10da1361&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10da1361"]])

export default __exports__